import type { EquipmentDataQueryCache, MoveFilteredInventoryPayload } from '@entities/equipment';

const SORT_INDEX_FIELD = 'sort_index';

export const moveFilteredInventoryInCache = ({
    previous,
    fromWarehouseId,
    toWarehouseId,
    inventoryGuids,
}: MoveFilteredInventoryPayload & {
    previous: EquipmentDataQueryCache | undefined;
    fromWarehouseId: number;
}): EquipmentDataQueryCache | undefined => {
    const equipment = previous?.data.response.equipment;

    if (!previous || !equipment || !inventoryGuids.length) {
        return previous;
    }

    const inventoryGuidSet = new Set(inventoryGuids);
    const sourceWarehouse = equipment.find((warehouse) => warehouse.id === fromWarehouseId);
    const targetWarehouse = equipment.find((warehouse) => warehouse.id === toWarehouseId);
    const movedItems =
        sourceWarehouse?.items.filter((item) => inventoryGuidSet.has(item.guid)) ?? [];

    if (!sourceWarehouse || !targetWarehouse || !movedItems.length) {
        return previous;
    }

    return {
        ...previous,
        data: {
            ...previous.data,
            response: {
                ...previous.data.response,
                equipment: equipment.map((warehouse) => {
                    if (warehouse.id === fromWarehouseId) {
                        return {
                            ...warehouse,
                            items: warehouse.items
                                .filter((item) => !inventoryGuidSet.has(item.guid))
                                .map((item, index) => ({
                                    ...item,
                                    [SORT_INDEX_FIELD]: index,
                                })),
                        };
                    }

                    if (warehouse.id === toWarehouseId) {
                        return {
                            ...warehouse,
                            items: [...warehouse.items, ...movedItems].map((item, index) => ({
                                ...item,
                                [SORT_INDEX_FIELD]: index,
                            })),
                        };
                    }

                    return warehouse;
                }),
            },
        },
    };
};
